export default __webpack_public_path__ + "static/media/icon-close-dark.ddf61a9d.svg";